import { useContext, useState } from 'react';
import Spinner from '../../../../reusable/spinner/spinner.component';
import Button from '../../../../reusable/button/button.component';
import { ToastContext } from '../../../../../contexts/toast.context';
import Client from '../../../../../tools/client';

import {
  MainContainer,
  InputContainer,
  UpdateLabel,
  UpdateInput,
  ButtonContainer,
  ButtonRowContainer
} from './update-shipping-provider.styles';

const client = new Client();

const UpdateShippingProvider = ({ provider, getProvider, setShowUpdate }) => {
  const [name, setName] = useState(provider.name);
  const [code, setCode] = useState(provider.code);
  const [trackingUrlTemplate, setTrackingUrlTemplate] = useState(provider.trackingUrlTemplate || '');
  const [loading, setLoading] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const updateProvider = async () => {
    setLoading(true);
    const payload = {
      name,
      code,
      trackingUrlTemplate
    };

    const res = await client.updateShippingProvider(provider.id, payload);

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to update provider');
      return;
    }

    successToast('Shipping provider updated');
    await getProvider();
    setLoading(false);
    setShowUpdate(false);
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <InputContainer>
            <UpdateLabel>Name:</UpdateLabel>
            <UpdateInput value={name} onChange={(e) => setName(e.target.value)} />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Code:</UpdateLabel>
            <UpdateInput value={code} onChange={(e) => setCode(e.target.value)} />
          </InputContainer>

          <InputContainer>
            <UpdateLabel>Tracking URL Template:</UpdateLabel>
            <UpdateInput
              value={trackingUrlTemplate}
              onChange={(e) => setTrackingUrlTemplate(e.target.value)}
            />
          </InputContainer>

          <ButtonContainer>
            <ButtonRowContainer>
              <Button onClick={() => setShowUpdate(false)}>Cancel</Button>
              <Button onClick={updateProvider}>Update</Button>
            </ButtonRowContainer>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateShippingProvider;